import {constructFilter} from './constructFilter';
import {TFunction} from 'i18next';

export const SECTION_ID_FLOORS = 'SECTION_ID_FLOORS';

export const constructFloorFilter = <TEntity extends {floorId: string}>(
  floors: {id: string; name: string}[],
  t: TFunction,
) =>
  constructFilter({
    sectionId: SECTION_ID_FLOORS,
    sectionTitle: t('Floor'),
    type: 'or',
    data: floors.map(({id, name}) => ({id, label: name})),
    defaultFilterOptions: [],
    predicate: (filter, entity: TEntity) => entity.floorId === filter.id,
  });
